import { ElementType, IElement } from '../../../models/Element';
import { ElementHeaderType } from '../../utils';

/**
 * Service keys as the Voys status feed names them. The website renders the
 * Dutch label; this list only decides which services the block shows.
 */
export const STATUS_SERVICES: ReadonlyArray<{ key: string; label: string }> = [
  { key: 'phone-traffic', label: 'Telefonie' },
  { key: 'freedom', label: 'Freedom' },
  { key: 'large-business-platform', label: 'Large Business Platform' },
  { key: 'ascend', label: 'Ascend' },
  { key: 'mobile-app', label: 'Mobiele app' },
  { key: 'desktop-app', label: 'Desktop app' },
];

export type StatusUpdates = IElement & {
  heading: string;
  heading_type: ElementHeaderType;
  hide_overview: boolean;
  services: Array<string>;
};

export const defaultStatusUpdates: StatusUpdates = {
  id: 0,
  name: ElementType.STATUS_UPDATES,
  heading: 'Status van onze diensten',
  heading_type: ElementHeaderType.H2,
  hide_overview: false,
  services: ['phone-traffic', 'freedom', 'mobile-app', 'desktop-app'],
};
